<script>
  import { onMount } from "svelte";
  export let entries = [];
  export let max = 200;

  let el;
  let scrollTop = 0;
  let scrollHeight = 0;
  let clientHeight = 0;
  let mounted = false;

  $: {
    entries = entries.slice(-max);
    scrollToBottom(scrollHeight, clientHeight);
  }

  $: atBottom = scrollTop >= scrollHeight - clientHeight;
  $: shouldAutoScroll = atBottom;
  $: present = entries.length > 0;
  $: empty = !present;

  onMount(() => {
    mounted = true;
    scrollToBottom(scrollHeight, clientHeight);
  });

  function directive(node, bar) {
    return {
      update(bar) {
        scrollHeight = el.scrollHeight;
      },
    };
  }

  function scrollToBottom(scrollHeight, clientHeight) {
    if (mounted) {
      scrollHeight = el.scrollHeight;
      if (shouldAutoScroll) {
        el.scrollTop = scrollHeight - clientHeight;
      }
    }
  }

  function handleScroll(e) {
    scrollTop = e.target.scrollTop;
  }
</script>

<style>
  .logs-container {
    display: block;
    height: 300px;
    background: #333;
    padding: 1em;
    overflow: auto;
    word-wrap: break-word;
    scrollbar-width: thin;
    scrollbar-color: blue orange;
    border-radius: 5px;
    resize: vertical;
  }

  .logs-container.empty {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Works on Chrome/Edge/Safari */
  .logs-container::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
  .logs-container::-webkit-scrollbar-track {
    background: #444;
  }
  .logs-container::-webkit-scrollbar-thumb {
    background-color: #666;
    border: 1px solid #444;
  }
  .entry {
    font-size: 12px;
    font-family: "Mono", Monaco, Menlo, Courier, monospace, monospace;
    line-height: 1.4;
  }
  .__entry-type__error {
    color: #e06c75;
  }
  .__entry-type__api-call {
    color: #56b6c2;
  }
  .__entry-type__state {
    color: #e5c07b;
  }

  .empty-placeholder {
    color: #888;
  }
</style>

<!-- <div>atBottom: {atBottom}; ScrollTop: {scrollTop}; scrollHeight: {scrollHeight}; clientHeight: {clientHeight}</div> -->
<div
  bind:this={el}
  use:directive={entries}
  on:scroll={handleScroll}
  bind:clientHeight
  class="logs-container"
  class:empty>
  {#each entries as entry}
    <slot {entry}>
      <div class="entry __entry-type__{entry.type}">{entry.message}</div>
    </slot>
  {:else}
    <div class="empty-placeholder">No logs yet ...</div>
  {/each}
</div>
